/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React from "react";
import { ItemWrapper, ValueWrapper, CloseIcon } from "./RemovableItem/index";

const RemovableItem = (props) => {
  const { item, value, onClick } = props;
  console.log("XXX RemovableItem: ", props)
  return (
    <ItemWrapper>
      <ValueWrapper>{value}</ValueWrapper>
      <CloseIcon className="close icon" onClick={(e) => onClick(e, item)} />
    </ItemWrapper>
  );
};

export default RemovableItem;
